module.exports = __webpack_public_path__ + "media/bootstrap-icons/node-minus-b20dcded.svg";